// SKUs del cliente. Mirror de la tabla `skus` (migración 00003).
// La capacidad estándar vive en `skus_lineas` (combinación SKU × línea).
import { z } from 'zod';
export const skuSchema = z.object({
    id: z.string().uuid(),
    tenant_id: z.string().uuid(),
    cliente_id: z.string().uuid(),
    codigo_cliente: z.string().trim().min(1).max(40),
    descripcion: z.string().trim().min(1).max(200),
    formato: z.string().trim().min(1).max(40).nullable(),
});
/**
 * Vista enriquecida que devuelve `/api/lineas/:id/skus` — incluye capacidad
 * estándar para esa combinación SKU × línea para que L2 muestre los rangos
 * de validación al líder (golpes/min, operarios típicos).
 */
export const skuConCapacidadSchema = skuSchema.extend({
    // La columna es NUMERIC(12,2): la capacidad puede tener decimales (ej. 1093.5
    // paq/h promediado). NO usar .int() — un solo valor decimal hacía fallar el
    // safeParse del array entero → 500 → L2 mostraba "sin SKUs" para toda la línea.
    capacidad_estandar_unidades_hora: z.number().positive().nullable(),
    capacidad_estandar_golpes_min: z.number().positive().nullable(),
    // La BD permite personas BETWEEN 1 AND 50 (no 20). Alineado con skus_lineas.
    personas_estandar_turno: z.number().int().min(1).max(50).nullable(),
    golpes_min_aplica: z.boolean(),
});
//# sourceMappingURL=sku.js.map